import React from "react";
import {
  Container,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Button,
  Form,
  
} from "shards-react";
import { Link } from "react-router-dom";
import TableRow from '../layout/TableRow';
import TableColumnRow from '../layout/TableColumnRow';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FcAcceptDatabase,FcApproval } from "react-icons/fc";
import ProjectFileDataService from "../../services/projectFile.service";
import ProcessFileService from "../../services/processFile.service";
import moment from "moment";
import {actions as AppActions} from "../../_stores/app.store";
import supplierService from "../../services/supplier.service";
import ProjectStructureDataService from "../../services/projectStructure.service";
import FunctionDataService from "../../services/function.service";
const columnIndex = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const INDIA = process.env.REACT_APP_MARKET === "INDIA";
const EGYPT = process.env.REACT_APP_MARKET === "EGYPT";

class ProjectFileDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectFileDetails:"",
      sourceTargetColumnMapping: [],
      fileUploaded:true,

      fileType:"",
      fileFormat:"",
      projectStructureName: "",
      skipRows: "",
      dataHeaderRow: "",
      validationColumn: "",
      exceptionKeywords: "",
      // exceptionKeywords: "SUTURE, USYNTH",
      sourceTargetColumnMapping: [],
      rows:"",
      columnsRows:"",
      columnsRowsMapping:"",
      headers:"",
      viewTable:false,
      masterTableFields:[],
      rowNoToremove: [],
      file: null,
      suppliernameRow: 1,
      supplierLocationRow: 2,
      reportTypeRow: 3,
      reportPeriodRow: 5,
      // inputTemplateheaderRow: 5,
      selectedReport: 'report1',
      templateName: 'report1',
      fileUploaded:false,
      fileName: "",

      showSeparator: false,
      showStartDateIndex: false,
      showEndDateIndex: false,
      showSupplierCodeIndex: false,

      showSupplierName : false,
      showSupplierStatmentPeriodRow: false,
      showSkipRows: false,
      shoDataHeaderRow: false,
      hasHeader: false

    };

    this.retrieveProjectFileDetails = this.retrieveProjectFileDetails.bind(this);
    this.testRun = this.testRun.bind(this);
    this.showTable = this.showTable.bind(this);
    this.clearData = this.clearData.bind(this);

  }

  // componentDidMount() {
  //   //this.retrieveProjectFileDetails();
  //   if(this.props.projectFileId)
  //   this.retrieveProjectFileDetails();

  //   this.showTable()
  // }

  componentDidMount() {
    AppActions.setLoading(true);
    this.retrieveFunctionDetails();
    this.retrieveSupplierList();
    this.retrieveProjectStructureList();

    if(this.props.projectFileId)
    this.retrieveProjectFileDetails();

    AppActions.setLoading(false);
  }



  retrieveFunctionDetails(){
    FunctionDataService.getAll().then((response) => {
      var fnDtls = response.data.data;
      this.setState({
        functionsList:fnDtls
      });
    });
  }

  retrieveSupplierList(){
    AppActions.setLoading(true);
    supplierService.getByProject(this.props.projectId).then((response) => {
      AppActions.setLoading(false);
      this.setState({
        supplierList:response.data.data,
        supplierFilteredList:response.data.data
      })
    });
  }
  
  retrieveProjectStructureList(){
    AppActions.setLoading(true);
		ProjectStructureDataService.getByProject(this.props.projectId).then((response) => {
      AppActions.setLoading(false);
      this.setState({
				projectStructureList:response.data.data,
			})
  	});
	}
  


  componentDidUpdate(prevProps) {
    if (this.props.projectFileId != prevProps.projectFileId)
      this.retrieveProjectFileDetails();
  }


  retrieveProjectFileDetails(){
   	ProjectFileDataService.get(this.props.projectFileId).then((response) => {
			var projectFileDetails = response.data.data;
        this.setState({
        projectFileDetails: projectFileDetails,

        id : projectFileDetails[0].projectSupplierId.id,
        selectedProjectSupplierName : projectFileDetails[0].projectSupplierId.supplierName,
        selectedProjectStructureName : projectFileDetails[0].projectStructureId.projectStructureName,
        selectedProjectFileName: projectFileDetails[0].projectFileName, 
        projectFileName: projectFileDetails[0].projectFileName,
        showStructureFormFields:true,
        projectStructureSelected:projectFileDetails[0].projectStructureId._id,
        supplierSelected:projectFileDetails[0].projectSupplierId._id,
    //    projectStructureId: projectFileDetails.projectStructureId,
    //    projectSupplierId: projectFileDetails.projectSupplierId,
        projectStructureName: projectFileDetails[0].projectStructureId.projectStructureName,
        fileType: projectFileDetails[0].structureSupplierMapping.fileType,
        fileFormat: projectFileDetails[0].structureSupplierMapping.fileFormat,
        skipRows: projectFileDetails[0].structureSupplierMapping.skipRows,
        dataHeaderRow: projectFileDetails[0].structureSupplierMapping.dataHeaderRow,
        mergedCell: projectFileDetails[0].structureSupplierMapping.mergedCell,
        validationColumn: projectFileDetails[0].structureSupplierMapping.validationColumn,
        exceptionKeywords: projectFileDetails[0].structureSupplierMapping.exceptionKeywords,
        
        separator :projectFileDetails[0].structureSupplierMapping.separator,
        startDate: projectFileDetails[0].structureSupplierMapping.startDate,
        endDate: projectFileDetails[0].structureSupplierMapping.endDate,
        supplierCode: projectFileDetails[0].structureSupplierMapping.supplierCode,

        supplierNameRow: projectFileDetails[0].structureSupplierMapping.supplierNameRow,
        fileName:projectFileDetails[0].structureSupplierMapping.file,
        reportPeriodRow: projectFileDetails[0].structureSupplierMapping.supplierStatmentPeriodRow,
        supplierName: "",
        reportPeriodRange: "",
        masterTableFields:projectFileDetails[0].structureSupplierMapping.sourceTargetColumnMapping,
        sourceTargetColumnMapping: projectFileDetails[0].structureSupplierMapping.sourceTargetColumnMapping,
        companyNameInColumns: projectFileDetails[0].projectStructureId.companyNameInColumns,
        hasHeader: projectFileDetails[0].projectStructureId.hasHeader,
			});


      if(projectFileDetails[0].projectStructureId.fileType === "textFile")
      {
        if(projectFileDetails[0].projectStructureId.hasHeader){
          this.setState({
            // supplierName : "",
            // supplierStatmentPeriodRow: "",
            // skipRows: "",
            // dataHeaderRow: "",
    
            showSupplierName : true,
            showSupplierStatmentPeriodRow: true,
            showSkipRows: true,
            shoDataHeaderRow: true,
            
            showseparator: false,
            showStartDateIndex: false,
            showEndDateIndex: false,
            showSupplierCodeIndex: false
          });
        } else {
          this.setState({
    
            supplierName : "",
            supplierStatmentPeriodRow: "",
            skipRows: "",
            dataHeaderRow: "",
    
            showSupplierName : false,
            showSupplierStatmentPeriodRow: false,
            showSkipRows: false,
            shoDataHeaderRow: false,
    
            showSeparator: true,
            showStartDateIndex: true,
            showEndDateIndex: true,
            showSupplierCodeIndex: true,
    
          });
        }
      }else if(projectFileDetails[0].projectStructureId.fileType === "excelFile"){
        this.setState({
         
          separator :"",
          startDate: "",
          endDate: "",
          supplierCode: "",
  
          showSupplierName : true,
          showSupplierStatmentPeriodRow: true,
          showSkipRows: true,
          shoDataHeaderRow: true,
          
          showSeparator: false,
          showStartDateIndex: false,
          showEndDateIndex: false,
          showSupplierCodeIndex: false
        });
      }else{
        this.setState({
         
          supplierName : "",
          supplierStatmentPeriodRow: "",
          skipRows: "",
          dataHeaderRow: "",
  
          showSupplierName : false,
          showSupplierStatmentPeriodRow: false,
          showSkipRows: false,
          shoDataHeaderRow: false,
  
          separator :"",
          startDate: "",
          endDate: "",
          supplierCode: "",
          
          showSeparator: false,
          showStartDateIndex: false,
          showEndDateIndex: false,
          showSupplierCodeIndex: false
  
  
        });
      }

  	});

   

	}

 
  
  testRun(){
      this.viewOriginalFile();
    }
  
  
   
    viewOriginalFile(file) {
  
      const { fileName } = this.state;
      let finalFileName = fileName;
      if(file){
        finalFileName = file.name;
      }
      
      if(finalFileName){
  
        AppActions.setLoading(true);
        const { sourceTargetColumnMapping } = this.state;

        const state = { ...this.state };
        delete state.masterTableFields;
        delete state.projectStructureList;
        delete state.supplierFilteredList;
        delete state.supplierList;
  
        ProcessFileService.viewOriginalFile({state: state, fileName: finalFileName, projectId: this.props.projectId  }).then((response) => {
          AppActions.setLoading(false);
          if(sourceTargetColumnMapping.length > 0){
            this.setState({ rows: response.data.output, headers: response.data.output.headerData, fileUploaded: true});
          } else {
            this.setState({ headers: response.data.output.headerData, fileUploaded: true});
          }
          
       this.setState({
         testRunBtn: true,
        });
  
          this.showTable();
        });
  
      } else {
        console.error('No File Name Provided');
      }
  
      
    }

  clearData(){
    localStorage.clear();
    this.setState({
      rows: ""
		});
  }

  showTable(){
    //alert();
    this.setState({
      viewTable: true,
		});

  }


  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}


  render() {
    const {
      clearData,
         projectFileDetails,
         file,
          fileUploaded,
          viewTable,
          showSeparator,
          showStartDateIndex,
          showEndDateIndex,
          showSupplierCodeIndex,
          showSupplierName,
          showSupplierStatmentPeriodRow,
          showSkipRows,
          shoDataHeaderRow,
      // PostsListFour
    } = this.state;
    
    const {
      projectId,
      projectStructureId
    // PostsListFour
  } = this.props;

  const id = this.state.projectFileDetails && this.state.projectFileDetails[0] && this.state.projectFileDetails[0].id;


  const totalRowProcessed = this.state.rows.rowData && this.state.rows.rowData.length > 0 ? this.state.rows.rowData.length : 0 || 0;
  const totalRowCount = this.state.rows.totalRowCount || 0;
  const totalEmptyRowCount = this.state.rows.totalEmptyRowCount || 0;
  
    return (
    <div>
      <Card small className="mb-4">
        <CardHeader className="border-bottom">
          <h6 className="m-0">
            File Configuration Details
            <Link className="btn btn-primary ml-4" to={"/project/"+projectId+"/file"}><FcAcceptDatabase /> View All</Link>
            {
              id && (<Link className="btn btn-primary ml-4" to={`/project/${projectId}/file/${id}/edit`}><FcAcceptDatabase /> Edit</Link>)
            }
          </h6>
        </CardHeader>
        <ListGroup flush>
          <ListGroupItem className="">
            <Form>
            {projectFileDetails && projectFileDetails.map(function (item,index){
              return(
                <Row form>
                <Col md="12" className="form-group">
                  <Row className="form-group-row">
                    <Col className="form-label" md="4"><label htmlFor="supplierSelected">Supplier</label></Col>
                    <Col className="form-field" md="8">{item.projectSupplierId && item.projectSupplierId.supplierName}</Col>
                  </Row>

                  <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="projectStructureSelected">Structure</label></Col>
                      <Col className="form-field" md="8">{item.projectStructureId.projectStructureName}</Col>
                    </Row>

                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="projectFileName">File Configuration Name</label></Col>
                      <Col className="form-field" md="8">{item.projectFileName}</Col>
                    </Row>
                
                    <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="fileType">File Type</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.fileType}</Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="fileFormat">File Format</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.fileFormat}</Col>
                    </Row>
                  
                    {showSeparator && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Separator</label></Col>
                        <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.separator}</Col>
                      </Row>
                      )
                    }
                    {showSupplierCodeIndex && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Supplier Code Index</label></Col>
                        <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.supplierCode}</Col>
                      </Row>
                      )
                    }
                    {showStartDateIndex && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Start Date Index</label></Col>
                        <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.startDate}</Col>
                      </Row>
                      )
                    }
                    {showEndDateIndex && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">End Date Index</label></Col>
                        <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.endDate}</Col>
                      </Row>
                      )
                    }
                    {INDIA && showSupplierName && (
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Supplier Name Row</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.supplierNameRow}</Col>
                    </Row>
                     )
                    }
                    {INDIA && showSupplierStatmentPeriodRow && (
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierStatmentPeriodRow">Supplier Statement period Row</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.supplierStatmentPeriodRow}</Col>
                    </Row>
                     )
                    }
                  
                    {INDIA && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compnayNameInColumns">Compnay Name In Columns</label></Col>
                        <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.companyNameInColumns === true ? 'True' : 'False'}</Col>
                      </Row>
                    )}

                    {INDIA && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compnayNameInRows">Compnay Name In Rows</label></Col>
                        <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.companyNameInRows === true ? 'True' : 'False'}</Col>
                      </Row>
                    )}

                    {showSkipRows && (
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="skipRows">Skip Rows</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.skipRows}</Col>
                    </Row>
                     )
                    }
                    {shoDataHeaderRow && (
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="dataHeaderRow">Data Header Row</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.dataHeaderRow}</Col>
                    </Row>
                     )
                    }
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="mergedColumns">Merged Columns</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.mergedColumns}</Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="validationColumn">Validation Column</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.validationColumn}</Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="exceptionKeywords">Exception Keywords</label></Col>
                      <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.exceptionKeywords}</Col>
                    </Row>
                    {(SAUDI || EGYPT) && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="fileDateFormat">File Date Format</label></Col>
                        <Col className="form-field" md="8">{item.structureSupplierMapping && item.structureSupplierMapping.fileDateFormat}</Col>
                      </Row>
                    )}
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="feFirstName">Select File</label></Col>
                      <Col className="form-field" md="8">
                      {/* {fileUploaded && ( */}
                          <div><FcApproval /> File Name : {item.structureSupplierMapping && item.structureSupplierMapping.file}</div>
                        {/* )} */}
                      </Col>
                    </Row>
                    <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="createdAt">Created Date </label></Col>
                        <Col className="form-field" md="8">{moment(new Date(item.createdAt)).format("DD/MM/yyyy hh:mm:ss A")}</Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="createdBy">Modified By </label></Col>
                        <Col className="form-field" md="8">{!(item.modifiedBy && !item.modifiedBy.name) ? "admin" : item.modifiedBy.name}</Col>
                      </Row>
                    <Row  className="form-group-row">
                      <Col className="form-field font-bold" md="12"><label htmlFor="feFirstName">Source Target Column Mapping</label></Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="3"><label htmlFor="source">Source</label></Col>
                      <Col className="form-label" md="3"><label htmlFor="target">Target</label></Col>
                      <Col className="form-label" md="3"><label htmlFor="columnLevelTransformation">Column Level Transformation</label></Col>
                      <Col className="form-label" md="3"><label htmlFor="computedColumn">Computed Column</label></Col>
                    </Row>
                    {item.structureSupplierMapping && item.structureSupplierMapping.sourceTargetColumnMapping && item.structureSupplierMapping.sourceTargetColumnMapping.map((mitem,mindex) => {
                      return(
                        <Row className="form-group-row" key={mindex+1}>
                          <Col className="form-label" md="3"><label htmlFor="feFirstName">{mitem.source || mitem.fieldName}</label></Col>
                          <Col className="form-label" md="3">{mitem.target}</Col>
                          <Col className="form-field" md="3">{mitem.columnLevelTransformation}</Col>
                          <Col className="form-field" md="3">{mitem.computedColumn}</Col>
                        </Row>
                        )
                      })
                    }
                 </Col>
              </Row>
              )
            })
            }

              <Row  className="form-row">
                <Col className="form-button" md="4">
                  <Button variant="primary" className="btn btn-primary float-left mr-3" onClick={this.testRun}> Test Run</Button>
                  {/* <button className="btn btn-primary" onClick={() => this.proccessFile()} theme="accent"><FcDataConfiguration /> Test Run</button> */}
                  {`Total Rows Count: ${totalRowCount}`}
                  <br />
                  {`Total Empty Rows Count: ${totalEmptyRowCount}`}
                  <br />
                  {`Total Rows processed: ${totalRowProcessed}`}
                </Col>
              </Row>  
            </Form>
            
            {viewTable && (
              <>
            <Container>
                    <Row>
                        <TableColumnRow
                            rows={this.state.columnsRows}
                            headers={this.state.headers}
                            clearData={clearData}
                        />
                    </Row>
                </Container>
              
              <Container className="mt-3">
                  <Row>
                      <TableRow
                          rows={this.state.rows}
                          clearData={clearData}
                      />
                  </Row>
              </Container>
              </>
              )
           }

          </ListGroupItem>
        </ListGroup>
        <ToastContainer />
      </Card>
      
    </div>
    )
  }
}


export default ProjectFileDetail;
